<template>
  <router-view/>
</template>

<style>
#app {
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
  position: absolute;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  mounted () {
    AOS.init()
  },
  created() {
    // Use in js
    (!this.$isMobile()) ? this.$router.push('/mobile') : '';
  }

}
</script>
